import React from 'react';

import Tooltip from 'ui-library/bs/Tooltip';

function StructuredFieldHeader({fieldDefinition}: StructuredFieldHeaderProps): JSX.Element {
  return (
    <Tooltip title={fieldDefinition.tableName}>
      <span>{fieldDefinition.name}</span>
    </Tooltip>
  );
}

interface StructuredFieldHeaderProps {
  fieldDefinition: {
    tableName: string;
    name: string;
  };
}

export default StructuredFieldHeader;
